<template>
  <div class="blog-main-content">
    <BlogList class="right"/>
    <h1>Rocky Waste & Stony Tomb (Terror Zone) Efficient Run Guide</h1>
    <p>When Rocky Waste & Stony Tomb become a Terror Zone, the most efficient way to farm is to focus only on <strong>Stony Tomb</strong> and skip Rocky Waste, for the following reasons:</p>

    <ul>
        <li><strong>High monster density</strong> in Stony Tomb, providing better experience gain.</li>
        <li><strong>No Cold Immune monsters</strong>, making it perfect for Cold-based builds.</li>
        <li><strong>High-end unique and set items</strong> can drop.</li>
        <li><strong>Open layout</strong>, making it ideal for ranged characters to farm efficiently.</li>
    </ul>

    <h2>Farming Route</h2>
    <ol>
        <li>Start from <strong>Lut Gholein</strong> in Act 2. There is no direct waypoint to this area.</li>
        <li>A Sorceress should teleport ahead to quickly locate <strong>Stony Tomb</strong> in Rocky Waste and open a portal.</li>
        <li>The entire team should enter Stony Tomb immediately and focus on farming inside.</li>
        <li>Clear the dungeon in a <strong>clockwise or counterclockwise manner</strong> to ensure no elite packs are missed.</li>
        <li>Once cleared, reset the game and repeat.</li>
    </ol>
    <p>⏳ <strong>Each run should be completed within 2-3 minutes</strong> to maximize efficiency.</p>

    <div id="slot-content_mpu" class="content-ad-mpu"/>

    <h2>Recommended Builds</h2>
    <p>Since Stony Tomb has no Cold Immune monsters, it is best suited for high-AOE damage builds. Recommended builds include:</p>
    <ul>
        <li><strong>Blizzard Sorceress</strong>
            <ul>
                <li>🔹 <strong>Skills:</strong> Blizzard + Frozen Orb</li>
                <li>🔹 <strong>Advantages:</strong></li>
                <ul>
                    <li>No Cold Immune monsters, allowing Blizzard to wipe out everything.</li>
                    <li>Can teleport ahead to scout and open a portal, improving team efficiency.</li>
                    <li>High AOE damage, ideal for clearing dense monster packs.</li>
                </ul>
            </ul>
        </li>
        <li><strong>Hurricane Druid</strong>
            <ul>
                <li>🔹 <strong>Skills:</strong> Tornado + Hurricane</li>
                <li>🔹 <strong>Advantages:</strong></li>
                <ul>
                    <li>Deals both physical and cold damage, bypassing immunity issues.</li>
                    <li>Tornado pierces through narrow corridors, dealing high damage to clustered enemies.</li>
                </ul>
            </ul>
        </li>
        <li><strong>Mosaic Assassin</strong>
            <ul>
                <li>🔹 <strong>Skills:</strong> Phoenix Strike</li>
                <li>🔹 <strong>Advantages:</strong></li>
                <ul>
                    <li>Extremely high area damage, perfect for dense monster areas.</li>
                    <li>With dual Mosaic runeword claws, elemental skills can be spammed indefinitely.</li>
                </ul>
            </ul>
        </li>
        <li><strong>Physical Bow Amazon</strong>
            <ul>
                <li>🔹 <strong>Skills:</strong> Strafe + Multishot</li>
                <li>🔹 <strong>Advantages:</strong></li>
                <ul>
                    <li>Excels in open areas, clearing large groups of monsters quickly.</li>
                    <li>Pure physical damage ensures stable DPS without immunity issues.</li>
                </ul>
            </ul>
        </li>
        <li><strong>Summon Necromancer</strong>
            <ul>
                <li>🔹 <strong>Skills:</strong> Raise Skeleton + Corpse Explosion</li>
                <li>🔹 <strong>Advantages:</strong></li>
                <ul>
                    <li>Skeletons act as a meat shield, making this build very safe.</li>
                    <li>Corpse Explosion scales with monster HP, dealing devastating AOE damage.</li>
                </ul>
            </ul>
        </li>
    </ul>

    <div>
      <img class="m-1 w-100" alt="Stony Tomb run" src="@/assets/runs/stony-tomb-run.png">
    </div>

    <h2>Farming Benefits</h2>
    <ul>
        <li><span class="highlight">High experience gain</span> – Area with many elite monsters.</li>
        <li><span class="highlight">Top-tier unique and set item drops</span> – High MF builds can farm <strong>Griffon’s Eye, Death’s Web, Stormshield, Crown of Age</strong>, and more.</li>
        <li><span class="highlight">Fast and efficient</span> – Each run should take 2-3 minutes, ideal for quick farming sessions.</li>
    </ul>

    <h2>Farming Tips</h2>
    <ul>
        <li><span class="highlight">Skip Rocky Waste</span> – Don’t waste time in the open area.</li>
        <li><span class="highlight">Teleport ahead to locate Stony Tomb and open a portal</span> – The team should start farming inside immediately.</li>
        <li><span class="highlight">Prioritize elite packs</span> – They give better loot and more experience.</li>
        <li><span class="highlight">Use high Magic Find (MF) gear</span> – Items like <strong>War Traveler, Chance Guards, and Enigma</strong> will improve drop rates.</li>
    </ul>
  </div>
</template>

<script>
import BlogList from '../BlogList.vue'

export default {
  name: 'StonyTomb',

  components: {
    BlogList,
  },
}
</script>